import { IElement } from "core-integration/src/store/elements/types";
import { IPick } from "core-integration/src/store/my-team/types";
import {
  getProposedElements,
  getSavedPicks,
} from "core-integration/src/store/squad/reducers";
import Pitch from "plos/src/components/Pitch";
import {
  defenderRow,
  forwardsRow,
  goalkeeperRow,
  midfielderRow,
} from "plos/src/components/Pitch/Pitch.css";
import { integerToMoneyWithCurrency } from "plos/src/utils/money";
import { positionsByElementType } from "plos/src/utils/positionsByElementType";
import { useSelector } from "react-redux";
import { SquadPitchUnit } from "../SquadPitchUnit";
import { SquadPitchProps } from "./types";

const SquadPitch = ({
  renderElementMenu,
  handleOpenElemListSheet,
  setPitchUnitRef,
}: SquadPitchProps) => {
  const proposedElements = useSelector(getProposedElements);
  const savedPicks = useSelector(getSavedPicks);
  const currencyDivisor = 10;

  const renderElementValueForPosition = (pos: number) => {
    const element: IElement = proposedElements[pos];
    const pick: IPick | undefined = savedPicks[pos];
    // Initial element selection (squad selection)
    if (!pick && element) {
      return integerToMoneyWithCurrency(element.now_cost, currencyDivisor);
    }
    // Removed element (transfers)
    if (pick && !element) {
      return integerToMoneyWithCurrency(pick.selling_price, currencyDivisor);
    }
    // Original element (transfers)
    if (pick && element && pick.element === element.id) {
      return integerToMoneyWithCurrency(pick.selling_price, currencyDivisor);
    }
    // Replaced element (transfers)
    if (pick && element && pick.element !== element.id) {
      return integerToMoneyWithCurrency(element.now_cost, currencyDivisor);
    }
    return null;
  };

  const rowClasses: Record<string, string> = {
    "1": goalkeeperRow,
    "2": defenderRow,
    "3": midfielderRow,
    "4": forwardsRow,
  };

  return (
    <Pitch sponsor="default">
      {Object.entries(positionsByElementType).map(
        ([elementType, positions]) => (
          <div key={elementType} className={rowClasses[elementType]}>
            {positions.map((position) => (
              <SquadPitchUnit
                key={position}
                pos={position}
                elementValue={renderElementValueForPosition(position)}
                renderElementMenu={renderElementMenu}
                handleOpenElemListSheet={handleOpenElemListSheet}
                pitchUnitRef={setPitchUnitRef(position)}
              />
            ))}
          </div>
        ),
      )}
    </Pitch>
  );
};

export default SquadPitch;
